import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

// Made from Material UI Switch componenet
// Reference: https://material-ui.com/api/switch/

const Toggle = withStyles({
    // Handle color
    switchBase: {
        color: 'white',
        '&$checked': {
            color: 'white',
          },
        '&$checked + $track': {
            backgroundColor: 'var(--focus-color)',
            opacity: 1,
        },
    },
    thumb: {},
    checked: {},
    track:{},

    // Handle size
    root: {
        width: 45,
        height: 24,
        padding: 6,
            '& $thumb': {
            width: 16,
            height: 16,
        },
        '& $switchBase': {
            padding: 4,
            '&$checked': {
                transform: 'translateX(22px)',
            },
        },
      },
})(Switch);

export default Toggle;

